// src/components/AnalyticsWrapper.tsx
/**
 * Wrapper component that automatically tracks analytics for the entire app
 * Wrap your App component with this to enable automatic tracking
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSession } from '../firebase/UserProvider';
import { 
  setAnalyticsUserId, 
  setAnalyticsUserProperties,
  logPageView 
} from '../firebase/analytics';

interface AnalyticsWrapperProps {
  children: React.ReactNode;
}

const AnalyticsWrapper: React.FC<AnalyticsWrapperProps> = ({ children }) => {
  const location = useLocation();
  const { user, isAdmin, isDoctor } = useSession();

  // Set user ID and properties when user logs in
  useEffect(() => {
    if (user) {
      setAnalyticsUserId(user.uid);
      
      setAnalyticsUserProperties({
        user_role: isAdmin ? 'admin' : isDoctor ? 'doctor' : 'patient',
        has_devices: user.devices && user.devices.length > 0,
        device_count: user.devices?.length || 0,
        doctor_name: typeof user.doctor === 'string' ? user.doctor : user.doctor?.name,
      });
    }
  }, [user, isAdmin, isDoctor]);

  // Track page views
  useEffect(() => {
    const pageName = location.pathname;
    const pageTitle = document.title;
    
    logPageView(pageName, pageTitle);
  }, [location.pathname]);

  return <>{children}</>;
};

export default AnalyticsWrapper;
